<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-big-eye`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M45.5 7A2.5 2.5 0 0043 4.5h-7.5v4.003h6.024V14.5H45.5V7zm-6.103 9.062C35.285 11.967 30.096 9.5 24 9.5c-5.548 0-10.633 2.467-14.918 6.536C6.022 18.94 3.5 22.736 3.5 24c0 1.265 2.517 5.06 5.575 7.964C13.358 36.034 18.444 38.5 24 38.5c5.554 0 10.638-2.474 14.925-6.554C41.975 29.044 44.5 25.244 44.5 24c0-1.317-2.245-5.09-5.103-7.938zM6.527 39.536V33.5H2.5V41A2.5 2.5 0 005 43.5h7.5v-3.964H6.527zM23.984 13.5c-4.327 0-8.547 1.912-12.32 5.476-1.372 1.295-2.613 2.756-3.552 4.16-.204.306-.386.599-.54.865.153.266.336.56.539.864.937 1.405 2.176 2.865 3.547 4.16 3.77 3.563 7.991 5.475 12.326 5.475 4.33 0 8.548-1.916 12.324-5.49 1.37-1.297 2.61-2.76 3.55-4.167.222-.332.419-.649.58-.933-.14-.279-.31-.587-.5-.907-.835-1.394-1.95-2.813-3.22-4.07-3.584-3.55-7.882-5.433-12.734-5.433zM31.5 24a7.5 7.5 0 10-15 0 7.5 7.5 0 0015 0zM24 20.5a3.5 3.5 0 100 7 3.5 3.5 0 000-7z"/></svg>
</template>
<script>

export default {
  name: 'IconBigEye',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
